/**
 * Navigation step states for the Rider app's MapScreen.
 *
 * Replaces the old magic-number system (0, 1, 2) with
 * readable, type-safe enum values.
 */
export enum RiderNavStep {
    /** Browsing / searching — address inputs, category selection */
    BROWSE = 'BROWSE',
    /** Booking confirmation — reviewing ride details & payment */
    BOOKING = 'BOOKING',
    /** Active ride — searching for driver / ride in progress */
    ACTIVE_RIDE = 'ACTIVE_RIDE',
}

/** Valid state transitions for RiderNavStep. */
export const VALID_NAV_TRANSITIONS: Record<RiderNavStep, RiderNavStep[]> = {
    [RiderNavStep.BROWSE]: [RiderNavStep.BOOKING, RiderNavStep.ACTIVE_RIDE],
    [RiderNavStep.BOOKING]: [RiderNavStep.BROWSE, RiderNavStep.ACTIVE_RIDE],
    [RiderNavStep.ACTIVE_RIDE]: [RiderNavStep.BROWSE],
};
